import React from "react";
import type {TitleProps} from "@refinedev/core";
import {Link} from "react-router";

export const Title: React.FC<TitleProps> = ({ collapsed }) => (
  <h6>
    <Link to="/" style={{ textDecoration: "none", color: "white" }}>
      {collapsed ? (
        <h1>I</h1>
        ) : (
        <h2> Immersive Admin Panel </h2>
      ) }
    </Link>
  </h6>
);